var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('faq-search',{attrs:{"search":_vm.search},on:{"update-search":_vm.updateSearch}}),_vm._v(" "),_c('faq-list',{attrs:{"openQuestions":_vm.openQuestions,"questions":_vm.filteredQuestions,"search":_vm.search}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }